import i18n from "@/i18n";

/** "12 Sep, 14:32" in the WIDGET's language (not the browser's), like `formatMoney`. */
export const formatDrawDate = (date: Date): string =>
  new Intl.DateTimeFormat(i18n.language || undefined, {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
